var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.608 8.81H5.39v9.695a3.24 3.24 0 0 0 3.24 3.24h6.736a3.24 3.24 0 0 0 3.24-3.24V8.81ZM4.14 7.56v10.945a4.49 4.49 0 0 0 4.49 4.49h6.736a4.49 4.49 0 0 0 4.49-4.49V7.56H4.142Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.68 7.462V4.698a2.35 2.35 0 0 0-4.701 0v2.764h4.7ZM12.33 1a3.698 3.698 0 0 0-3.698 3.698v4.111H16.027V4.698A3.698 3.698 0 0 0 12.329 1ZM12.223 12.402a1.171 1.171 0 1 0 0 2.342 1.171 1.171 0 0 0 0-2.342Zm-2.42 1.17a2.421 2.421 0 1 1 4.842 0 2.421 2.421 0 0 1-4.843 0Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.849 15.471v3.143h-1.25v-3.143h1.25Z",
    fill: "currentColor"
  })));
};
export default SvgLock;